import React from "react";
import { BannerMakerContainer } from "./containers";

const App: React.FC = () => {
  return <BannerMakerContainer />;
};

export default App;
